module.exports = __webpack_public_path__ + "static/media/01.e09f7ec8.jpg";